import React, { Fragment } from 'react'
import VertLine from "../../assets/icons/vert-line.svg"
import Arrow from "../../assets/icons/arrow-down-orange.svg"
import Img from 'gatsby-image'

const SeventyThirtySplit = ({ data }) => {
    const { 
        mainImage,
        content1,
        content2,
        title1,
        title2,
        listItem,
        listTitle1,
        listItems1,
        listTitle2,
        listItems2,
        lowerRightImage,
        isTimeline 
    } = data

    let styles = {};

    let pros = '';

    let timelineClass = '';

    if (listItems2) {
        styles.backgroundColor = '#D85123';
        pros = 'pros';
    } else {
        styles.backgroundColor = '#1B5375'; 
    }

    if (isTimeline) {
        timelineClass = 'is-timeline';
    }

    return (
        <section className="seventy-thirty-split">
            <div className={`left col ${timelineClass}`}>
                {
                mainImage ? 
                    <Fragment>
                        <div className="image-wrapper">
                            <Img 
                                fluid={mainImage?.localFile?.childImageSharp?.fluid}
                            />
                        </div>
                        <div className="upper-content">
                            {title1 && (
                                <h5>{title1}</h5>
                            )}
                            {content1 && (
                                <div dangerouslySetInnerHTML={{ __html: content1 }}></div>
                            )}
                        </div>
                        <div className="lower-content">
                            {title2 && (
                                <h5>{title2}</h5>
                            )}
                            {content2 && (
                                <div dangerouslySetInnerHTML={{ __html: content2 }}></div>
                            )}
                        </div>
                    </Fragment>
                 :  
                 isTimeline ? 
                    <Fragment>
                        <div className="icon-col">
                            {listItem ? listItem.map((item, index) => {
                                return (
                                    <Fragment key={index}>
                                        {item.icon && (
                                            <div className="icon">
                                                <Img 
                                                    fixed={item.icon?.localFile?.childImageSharp?.fixed}
                                                />
                                            </div>
                                        )}
                                        {listItem[index + 1] ? (
                                            <Fragment>
                                                <div className="icon">
                                                    <img alt="" src={ VertLine } />
                                                </div>
                                                <div className="icon">
                                                    <img alt="" src={ Arrow } />
                                                </div>
                                                <div className="icon">
                                                    <img alt="" src={ VertLine } />
                                                </div>
                                            </Fragment>
                                        ) : '' }
                                    </Fragment>
                                )
                            }) : null }
                        </div>
                        <div className="content-col">
                            {listItem ? listItem.map((item, index) => {
                                return (
                                    <div className="content" key={index}>
                                        {item.title && (
                                            <h5>{item.title}</h5>
                                        )}
                                        {item.content && (
                                            <div dangerouslySetInnerHTML={{ __html: item.content }}></div>
                                        )}
                                    </div>
                                )
                            }) : null }
                        </div>
                    </Fragment> 
                    :
                    listItem ? listItem.map((item, index) => {
                        return (
                            <div className="icon-list-item" key={index}>
                                {item.icon && (
                                    <div className="icon">
                                        <img alt="" src={item.icon?.localFile?.childImageSharp?.fixed.src} />
                                    </div>
                                )}
                                <div className="content">
                                    {item.title && (
                                        <h5>{item.title}</h5>
                                    )}
                                    {item.content && (
                                        <div dangerouslySetInnerHTML={{ __html: item.content }}></div>
                                    )}
                                </div>
                            </div>
                        )   
                    }) : null    
                }
            </div>
            <div className="right col">
                <div className="list-block" style={styles}>
                    {listTitle1 && (
                        <h5 className="list-head">{listTitle1}</h5>
                    )}
                    <ul className="list">
                        { listItems1 ? listItems1.map((item, index) => {
                            return <li className={`${pros}`} key={index}>{item.listItem}</li>
                        }) : null }
                    </ul>
                    {listItems2 && (
                        <Fragment>
                            <hr/>
                            {listTitle2 && (
                                <h5 className="list-head2">{listTitle2}</h5>
                            )}
                            <ul className="list">
                                { listItems2 ? listItems2.map((item, i) => {
                                    return <li className="cons" key={i}>{item.listItem}</li>
                                }) : null }
                            </ul>
                        </Fragment>
                    )}
                </div>
                <div className="image-wrapper">
                    {lowerRightImage && (
                        <Img 
                            fluid={lowerRightImage?.localFile?.childImageSharp?.fluid}
                        />
                    )}
                </div>
            </div>
        </section>
    )
}

export default SeventyThirtySplit
